import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import idx from 'idx';
import { STAGE_DONE } from 'focus_groups/ducks/vote';
import Tile from 'focus_groups/components/voting_tile';

export function mapStateToProps(state, { params }) {
  const { participantId } = params;
  const stage = idx(state, _ => _.project.focusGroups.vote.stage);

  return {
    participantId,
    showAverage: stage === STAGE_DONE
  };
}

export default withRouter(connect(mapStateToProps)(Tile));



// WEBPACK FOOTER //
// ./focus_groups/containers/voting_tile.js